import structureData from './bracketStructureV2.generated.json'

export const ROUND_ONE_LAYOUT = {
  left: [74, 77, 73, 75, 83, 84, 81, 82],
  right: [76, 78, 79, 80, 86, 88, 85, 87]
}

export const ROUND_TWO_LAYOUT = {
  left: [89, 90, 93, 94],
  right: [91, 92, 95, 96]
}

export const QUARTER_LAYOUT = {
  left: [97, 98],
  right: [99, 100]
}

export const SEMI_LAYOUT = {
  left: [101],
  right: [102]
}

const FIELD_INDEX = {
  ...Object.fromEntries(Array.from({ length: 16 }, (_, idx) => [73 + idx, `pick_r2_${idx + 1}`])),
  ...Object.fromEntries(Array.from({ length: 8 }, (_, idx) => [89 + idx, `pick_q${idx + 1}`])),
  ...Object.fromEntries(Array.from({ length: 4 }, (_, idx) => [97 + idx, `pick_s${idx + 1}`])),
  101: 'pick_f1',
  102: 'pick_f2',
  103: 'pick_third',
  104: 'pick_winner',
}

const dependencyFieldFor = (placeholder) => {
  const match = String(placeholder).match(/^(W|RU)(\d+)$/)
  if (!match) return null

  return FIELD_INDEX[Number(match[2])] || null
}

export const ROUND_ONE_MATCHUP_MAP = Object.fromEntries(
  structureData.roundOf32Matchups.map(({ matchNumber, pickStart }) => [matchNumber, pickStart])
)

const knockoutMatchFieldMap = Object.fromEntries(
  structureData.knockoutMatches.map(({ matchNumber, field, placeholderA, placeholderB }) => [
    matchNumber,
    {
      field,
      options: [dependencyFieldFor(placeholderA), dependencyFieldFor(placeholderB)].filter(Boolean),
    }
  ])
)

export const ROUND_OF_32_FIELDS = Array.from({ length: 32 }, (_, idx) => `pick_${idx + 1}`)
export const ROUND_OF_16_FIELDS = Array.from({ length: 16 }, (_, idx) => `pick_r2_${idx + 1}`)
export const QUARTER_FIELDS = Array.from({ length: 8 }, (_, idx) => `pick_q${idx + 1}`)
export const SEMI_FIELDS = Array.from({ length: 4 }, (_, idx) => `pick_s${idx + 1}`)
export const FINAL_FIELDS = ['pick_f1', 'pick_f2']
export const THIRD_FIELD = 'pick_third'
export const WINNER_FIELD = 'pick_winner'

export const FIELD_DEPENDENCIES = {
  ...Object.fromEntries(Array.from({ length: 16 }, (_, idx) => [`pick_r2_${idx + 1}`, [`pick_${(idx * 2) + 1}`, `pick_${(idx * 2) + 2}`]])),
  ...Object.values(knockoutMatchFieldMap)
    .filter(({ field }) => ![THIRD_FIELD, WINNER_FIELD].includes(field))
    .reduce((dependencies, { field, options }) => {
      dependencies[field] = options
      return dependencies
    }, {})
}

export const ROUND_TWO_MATCH_FIELDS = Object.fromEntries(
  Object.entries(knockoutMatchFieldMap).filter(([, { field }]) => field.startsWith('pick_q'))
)

export const QUARTER_MATCH_FIELDS = Object.fromEntries(
  Object.entries(knockoutMatchFieldMap).filter(([, { field }]) => field.startsWith('pick_s'))
)

export const SEMI_MATCH_FIELDS = Object.fromEntries(
  Object.entries(knockoutMatchFieldMap).filter(([, { field }]) => field.startsWith('pick_f'))
)
